import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { DocumentationDto } from '../../dtos/documentation.dto';

@Injectable()
export class DocumentationRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public getCatalogue(): Observable<DocumentationDto[]> {
    return this.http.get<DocumentationDto[]>(`${this.apiUrl}${API_ENDPOINTS.documentation.catalogue}`);
  }

  // Fetched as a blob through the authenticated client rather than pointed at with a plain URL: the
  // endpoint needs the session, so an <iframe src> straight to it would be an unauthenticated
  // request and would 401.
  public getContent(documentId: string): Observable<Blob> {
    return this.http.get(`${this.apiUrl}${API_ENDPOINTS.documentation.content(documentId)}`, {
      responseType: 'blob',
    });
  }
}
